import React, { useState } from 'react';
import UserGrid from './UsersAdministrationGrid';
import useUsersAdministrationPresenter from './UsersAdministrationPresenter';
import { Button, makeStyles, TextField } from '@material-ui/core';
import { commonFilter, commonActionHeader } from '../../constants/StyleConstants';
import AreaSelect from '../../components/AreaSelect';
import SelectAcerBrag from '../../components/SelectAcerBrag';
import { AddBox } from '@material-ui/icons';
import CreateUserDialog from './CreateUserDialog';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';
import { Fragment } from 'react';

const useStyles = makeStyles(theme => {
  return {
    ...commonFilter,
    ...commonActionHeader(theme),
  };
});

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const { criticos, setCriticos, name, setName, id, setId, status, setStatus, area, setArea, validateAndSearch, cleanFilters } = filtersProps;

  return (
    <div className={classes.filters}>
      <TextField
        margin="dense"
        id="razonSocialNombreYApellido"
        style={{ width: 200 }}
        label="Nombre"
        onChange={e => setName(e.target.value)}
        value={name}
      />
      <TextField margin="dense" id="idAdoProveedor" style={{ width: 200 }} label="ID" onChange={e => setId(e.target.value)} value={id} />
      <AreaSelect style={{ marginBottom: 4 }} value={area} setValue={setArea} />
      <SelectAcerBrag
        variableWidth
        rows={[
          { id: 'true', name: 'Activo' },
          { id: 'false', name: 'Inactivo' },
        ]}
        value={status}
        setValue={setStatus}
        style={{ marginBottom: 4 }}
        selectTitle="Estado"
      />
      <SelectAcerBrag
        variableWidth
        rows={[
          { id: 'todos', name: 'Todos' },
          { id: 'true', name: 'Si' },
          { id: 'false', name: 'No' },
        ]}
        value={criticos}
        setValue={setCriticos}
        style={{ marginBottom: 4 }}
        selectTitle="Proveedores críticos"
      />
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const UsersAdministration = () => {
  const classes = useStyles();
  const { firstLoad, rows, loading, search, ...filtersProps } = useUsersAdministrationPresenter();
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <CreateUserDialog open={open} setOpen={setOpen} reloadGrid={search} />
      <div className={classes.actionHeader}>
        <Button
          variant="contained"
          color="primary"
          className={classes.actionHeaderButton}
          startIcon={<AddBox />}
          onClick={() => setOpen(true)}>
          Nuevo Usuario
        </Button>
        
      </div>
      


      <ViewPortGridWrapper>
        <Filters filtersProps={filtersProps} />
        <DefaultUnrederedGridMessage render={!firstLoad}>
          <UserGrid data={rows} loading={loading} reloadGrid={search} />
        </DefaultUnrederedGridMessage>
      </ViewPortGridWrapper>
    </Fragment>
  );
};

export default UsersAdministration;
